/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ngx-pagination';
import * as import2 from '@angular/common';
class NgxPaginationModuleInjector extends import0.ɵNgModuleInjector<import1.NgxPaginationModule> {
  _CommonModule_0:import2.CommonModule;
  _NgxPaginationModule_1:import1.NgxPaginationModule;
  __NgLocalization_2:import2.NgLocaleLocalization;
  __PaginationService_3:import1.PaginationService;
  constructor(parent:import0.Injector) {
    super(parent,([] as any[]),([] as any[]));
  }
  get _NgLocalization_2():import2.NgLocaleLocalization {
    if ((this.__NgLocalization_2 == null)) { (this.__NgLocalization_2 = new import2.NgLocaleLocalization(this.parent.get(import0.LOCALE_ID))); }
    return this.__NgLocalization_2;
  }
  get _PaginationService_3():import1.PaginationService {
    if ((this.__PaginationService_3 == null)) { (this.__PaginationService_3 = new import1.PaginationService()); }
    return this.__PaginationService_3;
  }
  createInternal():import1.NgxPaginationModule {
    this._CommonModule_0 = new import2.CommonModule();
    this._NgxPaginationModule_1 = new import1.NgxPaginationModule();
    return this._NgxPaginationModule_1;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.CommonModule)) { return this._CommonModule_0; }
    if ((token === import1.NgxPaginationModule)) { return this._NgxPaginationModule_1; }
    if ((token === import2.NgLocalization)) { return this._NgLocalization_2; }
    if ((token === import1.PaginationService)) { return this._PaginationService_3; }
    return notFoundResult;
  }
  destroyInternal():void {
  }
}
export const NgxPaginationModuleNgFactory:import0.NgModuleFactory<import1.NgxPaginationModule> = new import0.NgModuleFactory<any>(NgxPaginationModuleInjector,import1.NgxPaginationModule);
const styles_PaginationControlsComponent:any[] = ['\n.ngx-pagination {\n  margin-left: 0;\n  margin-bottom: 1rem; }\n  .ngx-pagination::before, .ngx-pagination::after {\n    content: \' \';\n    display: table; }\n  .ngx-pagination::after {\n    clear: both; }\n  .ngx-pagination li {\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    margin-right: 0.0625rem;\n    border-radius: 0; }\n  .ngx-pagination li {\n    display: inline-block; }\n  .ngx-pagination a,\n  .ngx-pagination button {\n    color: #0a0a0a; \n    display: block;\n    padding: 0.1875rem 0.625rem;\n    border-radius: 0; }\n    .ngx-pagination a:hover,\n    .ngx-pagination button:hover {\n      background: #e6e6e6; }\n  .ngx-pagination .current {\n    padding: 0.1875rem 0.625rem;\n    background: #2199e8;\n    color: #fefefe;\n    cursor: default; }\n  .ngx-pagination .disabled {\n    padding: 0.1875rem 0.625rem;\n    color: #cacaca;\n    cursor: default; } \n    .ngx-pagination .disabled:hover {\n      background: transparent; }\n  .ngx-pagination .ellipsis::after {\n    content: \'…\';\n    padding: 0.1875rem 0.625rem;\n    color: #0a0a0a; }\n  .ngx-pagination a, .ngx-pagination button {\n    cursor: pointer; }\n\n.ngx-pagination .pagination-previous a::before,\n.ngx-pagination .pagination-previous.disabled::before { \n  content: \'«\';\n  display: inline-block;\n  margin-right: 0.5rem; }\n\n.ngx-pagination .pagination-next a::after,\n.ngx-pagination .pagination-next.disabled::after {\n  content: \'»\';\n  display: inline-block;\n  margin-left: 0.5rem; }\n\n.ngx-pagination .show-for-sr {\n  position: absolute !important;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0); }'];
export const RenderType_PaginationControlsComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_PaginationControlsComponent,
  data: {}
}
);
function View_PaginationControlsComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'a',([] as any[]),[[
        1,
        'aria-label',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),2).previous()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      ' '
    ]
    )),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'show-for-sr'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.previousLabel + ' ') + co.screenReaderPageLabel);
    ck(v,0,0,currVal_0);
    const currVal_1:any = co.previousLabel;
    ck(v,1,0,currVal_1);
    const currVal_2:any = co.screenReaderPageLabel;
    ck(v,3,0,currVal_2);
  });
}
function View_PaginationControlsComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      ' '
    ]
    )),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'show-for-sr'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.previousLabel;
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.screenReaderPageLabel;
    ck(v,3,0,currVal_1);
  });
}
function View_PaginationControlsComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'li',[[
        'class',
        'pagination-previous'
      ]
      ],[[
        2,
        'disabled',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[' \n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaginationControlsComponent_3)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaginationControlsComponent_4)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = (1 < import0.ɵnov((<any>(<any>v.parent).parent),2).getCurrent());
    ck(v,3,0,currVal_1);
    const currVal_2:any = import0.ɵnov((<any>(<any>v.parent).parent),2).isFirstPage();
    ck(v,6,0,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov((<any>(<any>v.parent).parent),2).isFirstPage();
    ck(v,0,0,currVal_0);
  });
}
function View_PaginationControlsComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),2).setCurrent((<any>v.parent).context.$implicit.value)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'show-for-sr'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.screenReaderPageLabel;
    ck(v,3,0,currVal_0);
    const currVal_1:any = (<any>v.parent).context.$implicit.label;
    ck(v,6,0,currVal_1);
  });
}
function View_PaginationControlsComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'show-for-sr'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),[' \n            ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.screenReaderCurrentLabel;
    ck(v,3,0,currVal_0);
    const currVal_1:any = (<any>v.parent).context.$implicit.label;
    ck(v,6,0,currVal_1);
  });
}
function View_PaginationControlsComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'li',([] as any[]),[[
        2,
        'current',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaginationControlsComponent_6)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaginationControlsComponent_7)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = (import0.ɵnov((<any>(<any>v.parent).parent),2).getCurrent() !== v.context.$implicit.value);
    ck(v,3,0,currVal_1);
    const currVal_2:any = (import0.ɵnov((<any>(<any>v.parent).parent),2).getCurrent() === v.context.$implicit.value);
    ck(v,6,0,currVal_2);
  },(ck,v) => {
    const currVal_0:any = (import0.ɵnov((<any>(<any>v.parent).parent),2).getCurrent() === v.context.$implicit.value);
    ck(v,0,0,currVal_0);
  });
}
function View_PaginationControlsComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'a',([] as any[]),[[
        1,
        'aria-label',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),2).next()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                 ',
      ' '
    ]
    )),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'show-for-sr'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.nextLabel + ' ') + co.screenReaderPageLabel);
    ck(v,0,0,currVal_0);
    const currVal_1:any = co.nextLabel;
    ck(v,1,0,currVal_1);
    const currVal_2:any = co.screenReaderPageLabel;
    ck(v,3,0,currVal_2);
  });
}
function View_PaginationControlsComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                 ',
      ' '
    ]
    )),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'show-for-sr'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.nextLabel;
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.screenReaderPageLabel;
    ck(v,3,0,currVal_1);
  });
}
function View_PaginationControlsComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'li',[[
        'class',
        'pagination-next'
      ]
      ],[[
        2,
        'disabled',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaginationControlsComponent_9)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaginationControlsComponent_10)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    const currVal_1:boolean = !import0.ɵnov((<any>(<any>v.parent).parent),2).isLastPage();
    ck(v,3,0,currVal_1);
    const currVal_2:any = import0.ɵnov((<any>(<any>v.parent).parent),2).isLastPage();
    ck(v,6,0,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov((<any>(<any>v.parent).parent),2).isLastPage();
    ck(v,0,0,currVal_0);
  });
}
function View_PaginationControlsComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'ul',[
      [
        'class',
        'ngx-pagination'
      ]
      ,
      [
        'role',
        'navigation'
      ]

    ]
      ,[[
        1,
        'aria-label',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaginationControlsComponent_2)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaginationControlsComponent_5)),
    import0.ɵdid(802816,(null as any),0,import2.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaginationControlsComponent_8)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.directionLinks;
    ck(v,3,0,currVal_1);
    const currVal_2:any = import0.ɵnov((<any>v.parent),2).pages;
    ck(v,6,0,currVal_2);
    const currVal_3:any = co.directionLinks;
    ck(v,9,0,currVal_3);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.screenReaderPaginationLabel;
    ck(v,0,0,currVal_0);
  });
}
export function View_PaginationControlsComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'pagination-template',([] as any[]),(null as any),[[
        (null as any),
        'pageChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import1.PaginationControlsComponent = v.component;
      if (('pageChange' === en)) {
        const pd_0:any = ((<any>co.pageChange.emit($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(737280,[[
        'p',
        4
      ]
    ],0,import1.PaginationControlsDirective,[
      import1.PaginationService,
      import0.ChangeDetectorRef
    ]
    ,{
      id: [
        0,
        'id'
      ]
      ,
      maxSize: [
        1,
        'maxSize'
      ]

    }
    ,{pageChange: 'pageChange'}),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaginationControlsComponent_1)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:import1.PaginationControlsComponent = v.component;
    const currVal_0:any = co.id;
    const currVal_1:any = co.maxSize;
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_2:boolean = !(co.autoHide && (import0.ɵnov(v,2).pages.length <= 1));
    ck(v,5,0,currVal_2);
  },(null as any));
}
function View_PaginationControlsComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'pagination-controls',([] as any[]),(null as any),(null as any),(null as any),View_PaginationControlsComponent_0,RenderType_PaginationControlsComponent)),
    import0.ɵdid(49152,(null as any),0,import1.PaginationControlsComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const PaginationControlsComponentNgFactory:import0.ComponentFactory<import1.PaginationControlsComponent> = import0.ɵccf('pagination-controls',import1.PaginationControlsComponent,View_PaginationControlsComponent_Host_0,{
  id: 'id',
  maxSize: 'maxSize',
  directionLinks: 'directionLinks',
  autoHide: 'autoHide',
  previousLabel: 'previousLabel',
  nextLabel: 'nextLabel',
  screenReaderPaginationLabel: 'screenReaderPaginationLabel',
  screenReaderPageLabel: 'screenReaderPageLabel',
  screenReaderCurrentLabel: 'screenReaderCurrentLabel'
}
,{pageChange: 'pageChange'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/~/ngx-pagination/dist/ngx-pagination.ngfactory.ts